import axios from 'axios';

const headers = (accessToken: string) => ({ authorization: accessToken });

export type CoachPromoProfilePayload = {
    representativeImageUrl?: string;
    representativeImageBase64?: string;
    headline?: string;
    tags?: string[];
    shortIntro?: string;
    isVisible?: boolean;
    sortOrder?: number;
};

export const getCoachPromoProfilesAPI = async (centerId: string, accessToken: string): Promise<any> => {
    const response = await axios({
        method: 'get',
        url: `${process.env.REACT_APP_SERVER}/v1/centers/${centerId}/coach-promo-profiles`,
        headers: headers(accessToken),
    });
    return response;
};

export const getCoachPromoProfileAPI = async (
    centerId: string,
    coachId: string,
    accessToken: string
): Promise<any> => {
    const response = await axios({
        method: 'get',
        url: `${process.env.REACT_APP_SERVER}/v1/centers/${centerId}/coach-promo-profiles/${coachId}`,
        headers: headers(accessToken),
    });
    return response;
};

export const updateCoachPromoProfileAPI = async (
    centerId: string,
    coachId: string,
    accessToken: string,
    body: CoachPromoProfilePayload
): Promise<any> => {
    const response = await axios({
        method: 'patch',
        url: `${process.env.REACT_APP_SERVER}/v1/centers/${centerId}/coach-promo-profiles/${coachId}`,
        headers: headers(accessToken),
        data: body,
    });
    return response;
};
